import type { ReactNode } from "react";
import { type Control, type FieldValues, type Path } from "react-hook-form";

import type { Option } from "@/components/molecules/SelectOptions/BaseSelectOptions";
import { FormControl, FormField, FormItem } from "@/components/ui/form";

import TagsBase from "./TagsBase";

interface TagsFieldProps<T extends FieldValues> {
  tagsList: Option[];
  title?: string | ReactNode;
  form: Control<T>;
  name: Path<T>;
  disabled?: boolean;
  optional?: boolean;
  multiple?: boolean;
}

const Tags = <T extends FieldValues>({
  tagsList,
  title,
  form,
  name,
  disabled,
  optional = false,
  multiple = true,
}: TagsFieldProps<T>) => (
  <FormField
    control={form}
    name={name}
    render={({ field }) => (
      <FormItem>
        <FormControl>
          <TagsBase
            tagsList={tagsList}
            selected={Array.isArray(field.value) ? field.value : []}
            onChange={field.onChange}
            disabled={disabled}
            title={title}
            optional={optional}
            multiple={multiple}
          />
        </FormControl>
      </FormItem>
    )}
  />
);

export default Tags;
